<template>
  <div>
    <div class="mx-4 mt-4 black--text">
      <div class="body-1 font-weight-medium">Petunjuk Pengisian</div>
      <div class="ml-2">Isi/check list kehadiran pada masing-masing sesi atau kegiatan</div>
    </div>
    <v-card outlined class="mx-3 my-6">
      <v-card-text class="py-2">
        <div class="title black--text">Daftar Kegiatan</div>
        <v-list class="py-0">
          <div v-for="(rubrik, rubrikId) in rubrikKehadiran" :key="rubrikId">
            <v-divider v-if="rubrikId > 0" />
            <v-list-item class="px-0">
              <v-list-item-content class="blue--text body-1 py-0">
                {{ rubrikId + 1 }}. {{ rubrik.keterangan }}
              </v-list-item-content>
              <v-list-item-action class="ma-0">
                <v-list-item-action-text>
                  <v-checkbox
                    v-model="form[rubrik.k_pelatihan_rubrik_psp]"
                    :value="5"
                    :readonly="mode === 'readonly'"
                  />
                </v-list-item-action-text>
              </v-list-item-action>
            </v-list-item>
          </div>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    initValue: {
      type: Object,
      default: () => {},
    },
    rubriks: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: 'form',
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    rubrikKehadiran() {
      return this.rubriks;
    },
  },
  methods: {
    reset() {
      this.$set(this, 'form', {});

      this.$nextTick(() => {
        const pspPelatihanKelasNilais = this.initValue['psp_pelatihan_kelas_nilais'] || [];
        const pspPelatihanKelasNilai = pspPelatihanKelasNilais[0] || {};
        const nilais = pspPelatihanKelasNilai.psp_pelatihan_kelas_rubriks || [];

        for (const nilai of nilais) {
          const kelompokId = this.$getDeepObj(nilai, 'm_pelatihan_rubrik_psp.kelompok_id');
          if (kelompokId === 'kehadiran') {
            this.$set(this.form, nilai.k_pelatihan_rubrik_psp, +nilai.k_nilai_psp);
          }
        }
      });
    },

    getValue() {
      let values = Object.assign({}, this.form || {});

      for (const key in values) {
        if (!values[key]) {
          delete values[key];
        }
      }

      return values;
    },

    onChangeNilai(item, skor) {
      if (this.mode !== 'form') return;
      this.$set(this.form, item.k_pelatihan_rubrik_psp, Number(skor));
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
